// src/components/BrokerRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import app from "../firebase";

const auth = getAuth(app);
const db = getFirestore(app);

// Wrap the broker dashboard with <BrokerRoute>...</BrokerRoute>
// Requires an approved doc at broker_applications/{uid} for the logged-in user.
const BrokerRoute = ({ children }) => {
  const [status, setStatus] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setStatus("denied");
        return;
      }
      try {
        const appSnap = await getDoc(doc(db, "broker_applications", user.uid));
        const approved = appSnap.exists() && appSnap.data().status === "approved";
        setStatus(approved ? "allowed" : "denied");
      } catch (err) {
        console.error(err);
        setStatus("denied");
      }
    });
    return () => unsub();
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Checking broker access...
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/broker-login" replace />;
  }

  return children;
};

export default BrokerRoute;
